import { useState } from "react";
import { Plus, Trash2, ThumbsUp } from "lucide-react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { TextField } from "@/components/tools/fields";

export const RM_STATUS = ["IDEA", "REVIEWING", "PLANNED", "IN DEVELOPMENT", "RELEASED"];

export const Roadmap = ({ items, reload }) => {
  const [title, setTitle] = useState("");
  const run = async (fn) => {
    try {
      await fn();
      reload();
    } catch (err) {
      toast.error(errorText(err));
    }
  };
  const add = (e) => {
    e.preventDefault();
    if (title.trim().length < 2) return;
    run(() => api.post("/admin/roadmap", { title })).then(() => setTitle(""));
  };
  return (
    <div className="space-y-5" data-testid="admin-roadmap">
      <form onSubmit={add} className="flex flex-wrap items-end gap-3">
        <div className="min-w-[240px] flex-1"><TextField id="rm-title" label="New feature request" value={title} onChange={setTitle} testid="roadmap-new-title" /></div>
        <button type="submit" className="btn btn-brand" data-testid="roadmap-add"><Plus size={16} aria-hidden /> Add</button>
      </form>
      <div className="grid gap-3 sm:grid-cols-5">
        {RM_STATUS.map((s) => <div key={s} className="rounded-2xl border-2 border-line bg-surface p-3 text-center"><p className="text-xs font-bold text-ink-soft">{s}</p><p className="font-display text-2xl">{items.filter((i) => i.status === s).length}</p></div>)}
      </div>
      <ul className="space-y-2">
        {items.map((f) => (
          <li key={f.id} className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border-2 border-line bg-surface p-4" data-testid={`roadmap-item-${f.id}`}>
            <span className="font-bold">{f.title}</span>
            <span className="flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-paper px-3 py-1 text-sm font-bold" data-testid={`roadmap-demand-${f.id}`}>Demand {f.demand}</span>
              <button type="button" onClick={() => run(() => api.post(`/admin/roadmap/${f.id}/demand`))} className="btn btn-ghost btn-sm" aria-label={`Add demand for ${f.title}`} data-testid={`roadmap-plus-${f.id}`}><ThumbsUp size={14} aria-hidden /></button>
              <label className="sr-only" htmlFor={`rm-${f.id}`}>Status for {f.title}</label>
              <select id={`rm-${f.id}`} value={f.status} onChange={(e) => run(() => api.patch(`/admin/roadmap/${f.id}`, { status: e.target.value }))} className="field-input py-1.5 text-sm" data-testid={`roadmap-status-${f.id}`}>
                {RM_STATUS.map((s) => <option key={s}>{s}</option>)}
              </select>
              <button type="button" onClick={() => window.confirm(`Delete "${f.title}"?`) && run(() => api.delete(`/admin/roadmap/${f.id}`))} className="btn btn-ghost btn-sm" aria-label={`Delete ${f.title}`} data-testid={`roadmap-delete-${f.id}`}><Trash2 size={14} aria-hidden /></button>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
